import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import pick from 'lodash/pick';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { sparesSetThunks } from 'shared/actions/searchForm';
import { toLocalized } from 'shared/helpers/locale';
import SearchPanel from '../../../../components/SearchPanel/SearchPanel';
import history from '../../../../../history';
import { generateSearchQuery, generateSparesSearchUrl } from "../../../../../shared/helpers/urls";

class SpareSearchBar extends React.Component {
  static propTypes = {
    transportType: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape(),
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    location: null,
  };

  getSearchUrl = state => {
    const pathname = generateSparesSearchUrl({ ...state, location: this.props.location });
    const allParams = generateSearchQuery(state);
    const query = pick(allParams, [...Object.keys(sparesSetThunks), 'transport']);

    return toLocalized(`/${pathname}?${queryString.stringify(query)}`, this.props.locale);
  };

  handleClearForm = () => {
    const pathname = generateSparesSearchUrl({
      transport: this.props.formState.transport,
      isNew: this.props.formState.isNew,
      location: this.props.location,
    });
    this.props.selectedActions.clearForm();
    history.push(toLocalized(`/${pathname}`, this.props.locale));
  };

  handleSetAge = age => {
    const { id: isNew } = age;
    const { set } = this.props.selectedActions;
    if (isNew === 1) {
      set.isNew(1);
      set.isUsed(null);
    } else if (isNew === 0) {
      set.isNew(null);
      set.isUsed(1);
    } else {
      set.isNew(null);
      set.isUsed(null);
    }
  };

  render() {
    const {
      transportType,
      formData,
      formVocabulary,
      selectedActions,
      formState,
      intl,
    } = this.props;
    const age = [
      {
        id: null,
        title: intl.formatMessage({ id: 'Все' }),
      },
      {
        id: 1,
        title: intl.formatMessage({ id: 'Новые' }),
      },
      {
        id: 0,
        title: intl.formatMessage({ id: 'б/у' }),
      },
    ];

    const isNewValue = parseFloat(formState.isNew);
    const isUsedValue = parseFloat(formState.isUsed);

    // change default value 0 to null
    if (isNewValue === 0) {
      selectedActions.set.isNew(null);
    }

    let numberIsNewValue = null;
    if (isNewValue === 1) {
      numberIsNewValue = 1;
    } else if (isUsedValue === 1) {
      numberIsNewValue = 0;
    }

    const modifiedFormState = {
      ...formState,
      isNew: numberIsNewValue,
    };

    return (
      <SearchPanel
        transportType={transportType}
        formVocabulary={formVocabulary}
        formData={formData}
        formState={modifiedFormState}
        selectedActions={selectedActions}
        //
        getSearchUrl={this.getSearchUrl}
        handleClearForm={this.handleClearForm}
        expandable={false}
        searchable={false}
        page="spares"
        cardTypes={intl.formatMessage(
          { id: '{count, plural, one {запчасть} few {запчасти} other {запчастей}}' },
          { count: parseFloat(formData.count) || 0 },
        )}
        withLocation
        age={age}
        setAge={this.handleSetAge}
      />
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  locale: globals.locale,
  location: globals.location,
});

export default injectIntl(connect(mapStateToProps)(SpareSearchBar));



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/components/SpareSearchBar/SpareSearchBar.js